module.exports = __webpack_public_path__ + "static/media/C++.8f42e018.png";